import { render, staticRenderFns } from "./LastGenerationCategoryPie.vue?vue&type=template&id=f554a558&scoped=true"
import script from "./LastGenerationCategoryPie.vue?vue&type=script&lang=ts"
export * from "./LastGenerationCategoryPie.vue?vue&type=script&lang=ts"
import style0 from "./LastGenerationCategoryPie.vue?vue&type=style&index=0&id=f554a558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f554a558",
  null
  
)

export default component.exports